import { Component, Input, OnInit } from '@angular/core';
import { VerificationTaskStatusEnum } from '../../../models/verification-tasks/enums/VerificationTaskStatusEnum';
import { StatusTask } from 'projects/admin/src/app/features/verification-tasks/models/ListData';

@Component({
  selector: 'app-verification-task-status',
  standalone: false,
  templateUrl: './verification-task-status.component.html'
})
export class VerificationTaskStatusComponent implements OnInit {

  @Input({ required: true }) status: StatusTask;
  verificationTaskStatus = VerificationTaskStatusEnum;

  constructor() { }

  ngOnInit() {
  }

}
